import { Typography } from '@mui/material';
import { translations } from '@aws-amplify/ui-react';
import { I18n } from 'aws-amplify/utils';
import Logo from './logo.png';
import StyledBox from './styles';

I18n.putVocabularies(translations);
I18n.putVocabulariesForLanguage('fr', {
  'login.title': 'Se connecter à CogNeed',
  'login.password': 'Entrez votre mot de passe',
  'login.email': 'Entrez votre adresse e-mail',
  'login.remember_me': 'Se souvenir de mon adresse e-mail',
});
I18n.putVocabulariesForLanguage('en', {
  'login.title': 'Sign in to CogNeed',
  'login.password': 'Enter your password',
  'login.email': 'Enter your email address',
  'login.remember_me': 'Remember my email address',
});

export default function SignInHeader() {
  return (
    <StyledBox maxWidth="sm">
      <div className="logo">
        <img src={Logo} style={{ width: '100%', height: 'auto' }} alt="CogNeed logo" />
      </div>
      <Typography variant="h1">
        {I18n.get('login.title')}
      </Typography>
    </StyledBox>
  );
}
